import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import {
  createShareReportResponseSchema,
  publicShareReportSchema,
  type CreateShareReportResponse,
  type PublicShareReport,
} from "@/schemas";

export const shareReportKeys = {
  byToken: (token: string) => ["share-report", token] as const,
};

export function useCreateShareReport() {
  return useMutation({
    mutationFn: async (companyId: number): Promise<CreateShareReportResponse> => {
      const data = await api.post<unknown>(`/companies/${companyId}/share-report`);
      return createShareReportResponseSchema.parse(data);
    },
  });
}

export function usePublicShareReport(token: string | undefined) {
  return useQuery({
    queryKey: token ? shareReportKeys.byToken(token) : ["share-report", "none"],
    enabled: !!token,
    retry: false,
    queryFn: async (): Promise<PublicShareReport> => {
      const data = await api.get<unknown>(`/share-reports/${token}`);
      return publicShareReportSchema.parse(data);
    },
  });
}
